<label>
  <input
    type="checkbox"
    [name]="name"
    [checked]="checked"
    [disabled]="disabled"
    [ngModel]="checked"
    (ngModelChange)="inputOnChange($event)"
  />
  <span class="sd-label"><ng-content></ng-content></span>
</label>
